import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';

export const RemainingLimitWrapper = withConfig(theme => styled('div', { label: 'RemainingLimitWrapper' })`
    display: flex;
    font-size: ${theme.star.fontSize.small};
    justify-content: space-between;
    margin-top: 8px;
`);

interface DepositLimitsLinkType {
    isSignup: boolean;
}

export const DepositLimitsLink = withConfig(theme => styled(Link, { label: 'DepositLimitsLink' })<DepositLimitsLinkType>`
    color: ${({ isSignup }): string => isSignup ? theme.star.topUp.txtColorQuinary : theme.star.accountDrawer.txtColorSecondary};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    text-decoration: none;
`);
